/** Overview tab: operational health/status, this-year financials, and shop detail cards. */
import Grid from '@mui/material/Grid';

import type { ShopSummary } from '../../api/types.ts';
import { ShopBillingCard } from './ShopBillingCard.tsx';
import { ShopContactCard } from './ShopContactCard.tsx';
import { ShopDevicesCard } from './ShopDevicesCard.tsx';
import { ShopFinancialsBand } from './ShopFinancialsBand.tsx';
import { ShopHealthStrip } from './ShopHealthStrip.tsx';
import { ShopProfileCard } from './ShopProfileCard.tsx';
import { ShopSyncHealthCard } from './ShopSyncHealthCard.tsx';

export interface ShopOverviewTabProps {
  shop: ShopSummary;
  canWrite: boolean;
  canManageConfig: boolean;
  /** The band calls GET /reports/summary, which needs reports:read -- hide it otherwise (avoids a 403). */
  canReadReports: boolean;
  canWriteReports: boolean;
  onMutated: () => void;
}

export function ShopOverviewTab({
  shop,
  canWrite,
  canManageConfig,
  canReadReports,
  canWriteReports,
  onMutated,
}: Readonly<ShopOverviewTabProps>): React.JSX.Element {
  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <ShopHealthStrip shop={shop} canWrite={canWrite} onStatusChanged={onMutated} />
      </Grid>
      {canReadReports && (
        <Grid size={12}>
          <ShopFinancialsBand shopId={shop.id} shopType={canWriteReports ? shop.shop_type : 'live'} />
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 6 }}>
        <ShopProfileCard shop={shop} canWrite={canWrite} onSaved={onMutated} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ShopContactCard shop={shop} canWrite={canWrite} onSaved={onMutated} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ShopSyncHealthCard shop={shop} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ShopDevicesCard shop={shop} canWrite={canWrite} onSaved={onMutated} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ShopBillingCard shop={shop} canManage={canManageConfig} onSaved={onMutated} />
      </Grid>
    </Grid>
  );
}

export default ShopOverviewTab;
